export default __webpack_public_path__ + "fonts/bookmark_white.svg";